import {useRouter} from 'next/router';
import {getLocaleContent} from '@helper/locale-content.js';
import BreadcrumbNav from '../common/BreadcrumbNav/index.js';
import {HomeOutlined} from '@ant-design/icons';

function NewsNavDetailsPress(props) {
    const {news} = props;
    const {locale} = useRouter();

    return (
        <div>
            <BreadcrumbNav
                items={[
                    {label: '', href: '/', icon: <HomeOutlined />},
                    {label: getLocaleContent(locale, 'page.press-news.page-title'), href: '/bao-chi-noi-ve-tnh'},
                    {label: news?.news_title || getLocaleContent(locale, 'page.press-news.press-detail')},
                ]}
            />
        </div>
    );
}

export default NewsNavDetailsPress;
